export default {
  title: 'Estimator24 Nasıl Çalışır',
  steps: [
    {
      title: 'Piyasa Analizi',
      description: 'Model, şehirdeki fiyatları ve trendleri analiz eder'
    },
    {
      title: 'Değerleme',
      description: 'Otomatik olarak mülk değerlemesi alırsınız'
    },
    {
      title: 'Analitik',
      description: 'Ek olarak benzer ilanları, grafikler ve önerileri görürsünüz'
    },
    {
      title: 'Karar',
      description: 'Verilere dayanarak yatırım veya kişisel kararınızı verirsiniz'
    }
  ]
}
